let prev = window.pageYOffset;
let up = null;
let down = null;
let wasUp = null;
let wasDown = null;

function dispatch() {
  const position = window.pageYOffset;
  if (position > prev) {
    down = true;
    up = false;
  } else if (position < prev) {
    down = false;
    up = true;
  } else {
    up = null;
    down = null;
  }
  prev = position;
  document.dispatchEvent(new CustomEvent('theme:scroll', {
    detail: {
      up,
      down,
      position,
    },
    bubbles: false,
  }));
  if (up && !wasUp) {
    document.dispatchEvent(new CustomEvent('theme:scroll:up', {
      detail: {position},
      bubbles: false,
    }));
  }
  if (down && !wasDown) {
    document.dispatchEvent(new CustomEvent('theme:scroll:down', {
      detail: {position},
      bubbles: false,
    }));
  }
  wasDown = down;
  wasUp = up;
}

function lock() {
  document.body.style = 'overflow-y:hidden; position: relative;';
}
function unlock() {
  document.body.style = 'overflow-y:visible; position: static;';
}


function scrollListener() {
  let timeout;
  window.addEventListener('scroll', function() {
    if (timeout) { window.cancelAnimationFrame(timeout); }
    timeout = window.requestAnimationFrame(function() {
      dispatch();
    });
  }, {passive: true});

  window.addEventListener('theme:scroll:lock', lock);
  window.addEventListener('theme:scroll:unlock', unlock);
}

export default scrollListener;
